import React, { useEffect } from "react";
import PaySuccessMessage from "../../images/PaySuccess.png";
import PayFailMessage from "../../images/PaymentFail.jpg";
import AppBar from "../../Components/header";
import * as qs from "query-string";
import { Link } from "react-router-dom";
import Parse from "parse";
export default function PaymentSuccess(props) {
  console.log("props", props);
  const parsed = qs.parse(props.location.search);

  console.log("parsed", parsed);
  useEffect(() => {
    async function CreateAppointmentWithZoom() {
      const Appointment = Parse.Object.extend("Appointment");
      const AppointmentPurpose = new Parse.Query(Appointment);
      await AppointmentPurpose.equalTo("transactionId", parsed.transactionid);
      let SetPayAppointment = await AppointmentPurpose.first();
      SetPayAppointment = {
        id: SetPayAppointment.id,
        ...SetPayAppointment.attributes,
      };
      console.log("SetPayAppointment", SetPayAppointment);

      const response = await Parse.Cloud.run("getZoomMeeting", {
        topic: "123Mentor Appointment",
        dateTime:
          SetPayAppointment.appointmentDate.substr(0, 11) +
          SetPayAppointment.appointmentTime +
          ":00",
        duration: SetPayAppointment.duration,
      });
      console.log("response", response);
      if (parsed.status === "pass") {
        const AppointmentSet = new Parse.Query(Appointment);
        await AppointmentSet.equalTo("transactionId", parsed.transactionid);
        let SetPay = await AppointmentSet.first();

        SetPay.set("Status", "Payment Success");
        SetPay.set("zoomMeeting", JSON.stringify(response));

        await SetPay.save();
        const NonCloudMail = await Parse.Cloud.run("NonCloudMail", {
          operation: "CreateAppointmentWithPaySuccess",
          SetPayAppointment: SetPayAppointment,
        });
        const WhatsappNotification = await Parse.Cloud.run(
          "SendWhatsAppNotification",
          {
            operation: "CreateAppointmentWithPaySuccess",
            SetPayAppointment: SetPayAppointment,
          }
        );

        console.log("NonCloudMail", NonCloudMail);
        console.log("whatsapp", WhatsappNotification);
      } else if (parsed.status === "fail") {
        const AppointmentSet = new Parse.Query(Appointment);
        await AppointmentSet.equalTo("transactionId", parsed.transactionid);
        let SetPay = await AppointmentSet.first();
        SetPay.set("Status", "Payment Failed");
        SetPay.save();
        const NonCloudMail = await Parse.Cloud.run("NonCloudMail", {
          operation: "CreateAppointmentWithPayFailed",
          SetPayAppointment: SetPayAppointment,
        });
        const WhatsappNotification = await Parse.Cloud.run(
          "SendWhatsAppNotification",
          {
            operation: "CreateAppointmentWithPayFailed",
            SetPayAppointment: SetPayAppointment,
          }
        );
        console.log("NonCloudMail", NonCloudMail);
        console.log("WhatsappNotification", WhatsappNotification);
      }
    }

    CreateAppointmentWithZoom();
  }, [parsed.status, parsed.transactionid]);
  return (
    <div>
      <AppBar />
      <center>
        {/* <Paper
          elevation={0}
        > */}
        <div
          style={{
            marginTop: "10vh",
            width: "50vh",
            height: "50vh",
          }}
        >
          {parsed.status === "pass" ? (
            <div>
              <img src={PaySuccessMessage} width="60vh" alt="" />
              <h4>
                Your Appointment has been created.
                <br />
                <br /> Have a greate Mentoring Session
                <br />
                <br />
                <Link
                  style={{
                    textDecoration: "none",
                  }}
                  to="/"
                >
                  {" "}
                  Click here{" "}
                </Link>
                to get back
              </h4>
            </div>
          ) : (
            <div>
              <img src={PayFailMessage} width="60vh" alt="" />
              <h4>
                Payment Failed
                <br />
                <br /> You can retry to create the appointment
                <br />
                <br />
                <Link
                  to="/"
                  style={{
                    textDecoration: "none",
                  }}
                >
                  {" "}
                  Click here{" "}
                </Link>
              </h4>
            </div>
          )}
          {/* </Paper> */}
        </div>
      </center>
    </div>
  );
}

// <!DOCTYPE html>
// <head>
//     <title></title>
// </head>
// <body>
//     <center >
//     <img src="./PaySuccess.png" style="margin-top:50px;"/>
//     <h3>Payment Successfull</h3>
//     <button onclick="document.location='https://123mentordev.back4app.io'">Back to Home Screen</button>

// </center>
// </body>
// </html>
